import React, { useEffect, useState } from "react";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const POLL_INTERVAL = 60000; // 5 sec
const MAX_DURATION = 7 * 60 * 1000; // 2 mins

export default function QuestionPaperUI({ jobId }) {
  const [status, setStatus] = useState("polling"); // polling | success | timeout
  const [pdfBase64, setPdfBase64] = useState(null);

  useEffect(() => {
    let intervalId;
    const startTime = Date.now();

    const poll = async () => {
      try {
        const id_token = sessionStorage.getItem('id_token')
        const res = await fetch("https://list-storage-bucket-files-188976723880.europe-west1.run.app", {
          method: "POST",
          headers: { 
            "Content-Type": "application/json",
            Authorization: `Bearer ${id_token}`,
           },
          body: JSON.stringify({ 
            "prefix":"question/"+jobId+".pdf" 
          })
        });

        const data = await res.json();

        if (data.file_data.length>0 && data.file_data[0].name=== jobId+".pdf") {
          setPdfBase64(data.file_data[0].content);
          setStatus("success");
          clearInterval(intervalId);
        }

        if (Date.now() - startTime > MAX_DURATION) {
          setStatus("timeout");
          clearInterval(intervalId);
        }
      } catch (err) {
        console.error(err);
      }
    };

    intervalId = setInterval(poll, POLL_INTERVAL);
    poll(); // immediate call

    return () => clearInterval(intervalId);
  }, [jobId]);

  const downloadPdf = () => {
    const link = document.createElement("a");
    link.href = `data:application/pdf;base64,${pdfBase64}`;
    link.download = "question-paper.pdf";
    link.click();
  };

  if (status === "polling") {
    return (
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        <CircularProgress size={20} />
        <Typography>Generating question paper…</Typography>
      </Box>
    );
  }

  if (status === "timeout") {
    return (
      <Typography color="error">
        Question paper generation is taking longer than expected.
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        p: 2,
        borderRadius: "12px",
        background: "#f5f7fb",
        width: "fit-content"
      }}
    >
      <PictureAsPdfIcon color="error" fontSize="large" />
      <Box>
        <Typography fontWeight={600}>
          Question paper generated
        </Typography>
        <Button size="small" onClick={downloadPdf}>
          Download PDF
        </Button>
      </Box>
    </Box>
  );
}
